import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const History = () => {
	return (
		<Stack alignItems="center" justifyContent="center" spacing={1.25} sx={{ px: 3, py: { xs: 8, md: 12 }, textAlign: "center" }}>
			<Box
				sx={{
					width: 48,
					height: 48,
					borderRadius: 2,
					display: "grid",
					placeItems: "center",
					bgcolor: "#f3f4f6",
					color: "#6b7280",
				}}>
				<HistoryRoundedIcon />
			</Box>
			<Typography sx={{ fontWeight: 700, color: "#111827" }}>History is not available yet</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380 }}>
				Past query runs will appear here once this section is ready. Use Run Query to compare Unicommerce and Ginesys in the meantime.
			</Typography>
		</Stack>
	);
};

export default History;
